<template>

  <v-row>
    <v-col class="text-center">
      <v-btn class="ma-2" tile outlined color="primary" @click="save(path)">
        <v-icon left>settings</v-icon>
        {{ $t('Settings.save')}}
      </v-btn>
    </v-col>
    <v-col class="text-center">
      <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
        <v-icon left>mdi-arrow-left</v-icon>
        {{ $t('Settings.back')}}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    username: String,
    mail: String,
    userId: String,
    path: String,
    currentPassword: String,
    newPassword: String,
    checkForm: Boolean,
    checkPass: Boolean
  },
  methods: {
    save: function(path) {
      switch (path) {
        case "user":
          axios
            .put(
              process.env.VUE_APP_API_ADDR + "/api/user/@me",
              {
                username: this.username,
                mail: this.mail
              },
              {
                headers: { Authorization: tokenStore.getToken() }
              }
            )
            .then(res => {
              if (res.data.success) {
                tokenStore.refreshToken();
                this.$emit("saved", this.$t('Settings.Alert.saved-info'));
              }
            })
            .catch(err => {
              this.$emit("error", err.response.data.errorMessage);
            });
          break;
        case "password":
          if (this.checkPass) {
            if (this.checkForm) {
              axios
                .put(
                  process.env.VUE_APP_API_ADDR +
                    "/api/user/@me/password",
                  {
                    newPassword: this.newPassword,
                    verifNewPassword: this.newPassword,
                    oldPassword: this.currentPassword
                  },
                  {
                    headers: { Authorization: tokenStore.getToken() }
                  }
                )
                .then(res => {
                  if (res.data.success) {
                    this.$emit("saved", this.$t('Settings.Alert.saved-pass'));
                  }
                })
                .catch(err => {
                  this.$emit("error", err.response.data.errorMessage);
                });
            } else {
              this.$emit("error", "Complete correctly the form");
            }
          } else {
            this.$emit("error", "Incorrect password");
          }

          break;
      }
    }
  }
};
</script>


